// Sweepstakes end moment — drives the "Want a chance to meet Speed?" countdown
// panel on the explore view. SWAP THIS for the real end date.
export const SWEEPSTAKES_END_AT = new Date("2026-09-07T23:59:00-07:00").getTime();
